import React, { useState, useEffect } from "react";
import io from "socket.io-client";
import useCurrentUser from "../../hooks/useCurrentUser";
import useUrls from "../../hooks/useUrls";

const SocketTest = () => {
  const currentUser = useCurrentUser();
  const [response, setResponse] = useState("");
  const { socketUrl } = useUrls();

  useEffect(() => {
    const socket = io(socketUrl, {
      query: { roomId: "test", username: currentUser.obj.username },
    });
    console.log("socket", socket);

    socket.on("connect", () => {
      setResponse("connected");
      console.log("socket connected", socket.id);
    });

    socket.on("draft:hello", (data) => {
      setResponse(data);
    });

    socket.on("disconnect", () => {
      console.log("socket disconnected", socket.id);
    });
  }, [currentUser, socketUrl]);

  return <div>{response}</div>;
};

export default SocketTest;
